import { Row, Col, Card } from "antd";
import { useEffect } from "react";
import { fadeIn } from "react-animations";
import { fadeInLeft } from "react-animations";
import Radium, { StyleRoot } from "radium";
import { settings } from "../../Settings";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { Player } from "video-react";

const styles = {
  fadeIn: {
    animation: "x 1s",
    animationName: Radium.keyframes(fadeIn, "fadeIn")
  },
  fadeInLeft: {
    animation: "x 2s",
    animationName: Radium.keyframes(fadeInLeft, "fadeInLeft")
  }
};

const Industrie = () => {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const getImages = (x, path, ext) => {
    x++;

    return path + x + ext;
  };
  return (
    <StyleRoot>
      <div style={styles.fadeInLeft}>
        <Row
          justify="center"
          style={{ backgroundColor: "#00738e", paddingBottom: "2vh" }}
        >
          <div className="bl--title-page">Industrie</div>
        </Row>
      </div>
      <Row>
        <Col span={20} push={2}>
          <Card
            style={{ height: "100%", marginTop: "3vh" }}
            className="bestlab--card-title"
            title="Sit controls"
            bordered={false}
          >
            <Row>
              <Col span={24}>
                <div>
                  <Slider {...settings}>
                    {Array.apply(null, Array(9)).map((el, x) => (
                      <div>
                        <img
                          className="bl--slider-img bl--slider-about "
                          src={getImages(
                            x,
                            "/images/industrie/sit_controls/",
                            ".jpg"
                          )}
                        />
                      </div>
                    ))}
                  </Slider>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col span={20} push={2}>
          <Card
            style={{ height: "100%", marginTop: "5vh" }}
            className="bestlab--card-title"
            title="SOPAL Sfax"
            bordered={false}
          >
            <Row>
              <Col span={24}>
                <div>
                  <Slider {...settings}>
                    {Array.apply(null, Array(5)).map((el, x) => (
                      <div>
                        <img
                          className="bl--slider-img bl--slider-about "
                          src={getImages(x, "/images/industrie/sopal/", ".JPG")}
                        />
                      </div>
                    ))}
                  </Slider>
                </div>
              </Col>
            </Row>
            <Row justify="center" style={{ marginTop: "4vh" }}>
              <Col xl={1} md={2} xs={0}></Col>
              <Col xl={18} md={20} xs={24}>
                <Player
                  autoPlay
                  playsInline
                  poster="/images/best_lab_blue.png"
                  src="/images/sopal.mp4"
                />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col span={20} push={2}>
          <Card
            style={{ height: "100%", marginTop: "7vh" }}
            className="bestlab--card-title"
            title="SOTUVER Jbel wouset"
            bordered={false}
          >
            <Row>
              <Col span={24}>
                <div>
                  <Slider {...settings}>
                    {Array.apply(null, Array(6)).map((el, x) => (
                      <div>
                        <img
                          className="bl--slider-img bl--slider-about "
                          src={getImages(
                            x,
                            "/images/industrie/sotuver/",
                            ".jpg"
                          )}
                        />
                      </div>
                    ))}
                  </Slider>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <div style={styles.fadeIn}>
        <Row
          style={{
            backgroundColor: "#00738e",
            height: "6vh",
            marginTop: "8vh",
            textAlign: "center"
          }}
        >
          <Col span="24" style={{ textAlign: "center" }}>
            <p className="bl--description">
              Vente équipements, Verreries,accessoires et Produits chimiques
            </p>
          </Col>
        </Row>
      </div>
    </StyleRoot>
  );
};

export default Industrie;
